<script setup lang="ts">
import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";
import { ProgramId } from "@/data/common/ids";
import { ProgramColorName } from "@/domains/v4b/program/program.types";

import ProgramIcon from "@/components/programming/program-icon.vue";

const props = defineProps<{
  programName: string;
  programId: ProgramId;
  programColor: ProgramColorName;
}>();
defineSlots<{
  default: () => void;
}>();
</script>

<template>
  <div
    class="flex border rounded-2xl p-4 items-center gap-3 hover:border-gray-400"
    :data-test-id="DATA_TEST_IDS.components.selectProgram.programSelectionCard.card"
    :data-test-program-id="props.programId"
  >
    <ProgramIcon
      :program-color="props.programColor"
      size="small"
    />
    <span
      class="font-semibold text-base flex-1 truncate"
      :data-test-id="DATA_TEST_IDS.components.selectProgram.programSelectionCard.programName"
      >{{ props.programName }}</span
    >
    <slot />
  </div>
</template>
